(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["trs-gallery"] && !Shopify.designMode) return;
  try {
    

  if (!customElements.get('trs-photo-gallery')) {
    customElements.define('trs-photo-gallery', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.dialog = this.querySelector('dialog');
        this.photos = Array.from(this.querySelectorAll('[data-gallery-photo]'));
        this.track = this.querySelector('.trs-gallery__viewport');
        this.thumbnails = Array.from(this.querySelectorAll('[data-slide-thumbnail]'));
        this.activeSlide = 0;
        const previous = this.querySelector('[data-slide-previous]');
        const next = this.querySelector('[data-slide-next]');
        previous.hidden = this.photos.length < 2;
        next.hidden = this.photos.length < 2;
        this.querySelector('[data-slide-thumbnails]').hidden = this.photos.length < 2;
        previous.addEventListener('click', () => this.goSlide(this.activeSlide - 1), options);
        next.addEventListener('click', () => this.goSlide(this.activeSlide + 1), options);
        this.thumbnails.forEach((thumbnail, index) => thumbnail.addEventListener('click', () => this.goSlide(index), options));
        this.track.addEventListener('scroll', () => {
          const index = Math.round(this.track.scrollLeft / this.track.clientWidth);
          if (Number.isFinite(index)) this.updateSlide(index);
        }, options);
        this.track.addEventListener('keydown', event => {
          if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
            event.preventDefault();
            this.goSlide(this.activeSlide + (event.key === 'ArrowLeft' ? -1 : 1));
          }
        }, options);
        this.resizeObserver?.disconnect();
        this.resizeObserver = new ResizeObserver(() => this.goSlide(this.activeSlide, false));
        this.resizeObserver.observe(this.track);
        this.updateSlide(0);
        this.photos.forEach((photo, index) => {
          photo.addEventListener('click', event => {
            if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
            if (typeof this.dialog.showModal !== 'function') return;
            event.preventDefault();
            this.opener = photo;
            this.showPhoto(index);
            this.dialog.showModal();
            this.savedOverflow = document.documentElement.style.overflow;
            document.documentElement.style.overflow = 'hidden';
            this.locked = true;
          }, options);
        });
        this.querySelector('[data-gallery-close]').addEventListener('click', () => this.dialog.close(), options);
        this.querySelector('[data-gallery-previous]').addEventListener('click', () => this.showPhoto(this.index - 1), options);
        this.querySelector('[data-gallery-next]').addEventListener('click', () => this.showPhoto(this.index + 1), options);
        this.dialog.addEventListener('keydown', event => {
          if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
            event.preventDefault();
            this.showPhoto(this.index + (event.key === 'ArrowLeft' ? -1 : 1));
          }
        }, options);
        this.dialog.addEventListener('click', event => {
          if (event.target === this.dialog) this.dialog.close();
        }, options);
        this.dialog.addEventListener('close', () => {
          this.unlockScroll();
          if (this.opener?.isConnected) this.opener.focus({ preventScroll: true });
        }, options);
      }
      goSlide(index, animate = true) {
        if (!this.photos.length) return;
        const next = (index + this.photos.length) % this.photos.length;
        const behavior = animate && !matchMedia('(prefers-reduced-motion: reduce)').matches ? 'smooth' : 'instant';
        this.track.scrollTo({ left: next * this.track.clientWidth, behavior });
        this.updateSlide(next);
      }
      updateSlide(index) {
        this.activeSlide = Math.max(0, Math.min(index, this.photos.length - 1));
        this.thumbnails.forEach((thumbnail, i) => {
          if (i === this.activeSlide) thumbnail.setAttribute('aria-current', 'true');
          else thumbnail.removeAttribute('aria-current');
        });
        const selected = this.thumbnails[this.activeSlide];
        if (selected) {
          const strip = selected.parentElement;
          const left = selected.offsetLeft - strip.offsetLeft;
          if (left < strip.scrollLeft) strip.scrollLeft = left;
          else if (left + selected.offsetWidth > strip.scrollLeft + strip.clientWidth) strip.scrollLeft = left + selected.offsetWidth - strip.clientWidth;
        }
        const counter = this.querySelector('[data-slide-count]');
        counter.textContent = this.photos.length ? counter.dataset.format.replace('[current]', this.activeSlide + 1).replace('[total]', this.photos.length) : '';
      }
      showPhoto(index) {
        this.index = (index + this.photos.length) % this.photos.length;
        const photo = this.photos[this.index];
        const image = new Image();
        image.alt = photo.querySelector('img').alt;
        image.src = photo.href;
        this.querySelector('[data-gallery-stage]').replaceChildren(image);
        this.querySelector('[data-gallery-caption]').textContent = photo.closest('figure').querySelector('figcaption')?.textContent || '';
        const counter = this.querySelector('[data-gallery-count]');
        counter.textContent = counter.dataset.format.replace('[current]', this.index + 1).replace('[total]', this.photos.length);
      }
      unlockScroll() {
        if (this.locked) document.documentElement.style.overflow = this.savedOverflow;
        this.locked = false;
      }
      disconnectedCallback() {
        this.unlockScroll();
        this.resizeObserver?.disconnect();
        this.controller?.abort();
      }
    });
  }


  } catch(e) { console.error(e); }
})();
})();
